import { toast } from "../components/razor-reuse";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";
import {
  GetReferralEarningsChartParams,
  GetReferralListParams,
  ReferralState,
  UpdateReferralSettingsPayload,
} from "./type";
import { generateQueryString } from "../helper/helpers";

export const getReferralOverviewStat = createAsyncThunk(
  "web/referral-overview-stats",
  async (_, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/referral/overview-stats`,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        thunkAPI.dispatch(SET_OVERVIEW_STATS(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getReferralRewardDistribution = createAsyncThunk(
  "web/referral-reward-distribution",
  async (_, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/referral/reward-distribution`,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        thunkAPI.dispatch(SET_REWARD_DISTRIBUTION(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getReferralProgramStatus = createAsyncThunk(
  "web/referral-program-status",
  async (_, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/referral/program-status`,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        thunkAPI.dispatch(SET_PROGRAM_STATUS(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const publishReferralProgram = createAsyncThunk(
  "web/referral-publish",
  async (_, thunkAPI) => {
    try {
      const data = await axios.patch(`/admin/referral/publish`);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });
        thunkAPI.dispatch(getReferralProgramStatus() as any);
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const unpublishReferralProgram = createAsyncThunk(
  "web/referral-unpublish",
  async (_, thunkAPI) => {
    try {
      const data = await axios.patch(`/admin/referral/unpublish`);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });
        thunkAPI.dispatch(getReferralProgramStatus() as any);
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getReferralList = createAsyncThunk(
  "web/referral-list",
  async (payload: GetReferralListParams, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/referral${generateQueryString(payload)}`,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data;
        thunkAPI.dispatch(SET_REFERRALS(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getReferralEarningsChart = createAsyncThunk(
  "web/referral-earnings-chart",
  async (payload: GetReferralEarningsChartParams, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/referral/earnings-chart${generateQueryString(payload)}`,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        thunkAPI.dispatch(SET_EARNINGS_CHART(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getReferralLinkExpiryStats = createAsyncThunk(
  "web/referral-link-expiry-stats",
  async (_, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/referral/link-expiry-stats`,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        thunkAPI.dispatch(SET_LINK_EXPIRY_STATS(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getReferralSettings = createAsyncThunk(
  "web/referral-settings",
  async (_, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/referral/settings`,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        thunkAPI.dispatch(SET_REFERRAL_SETTINGS(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const updateReferralSettings = createAsyncThunk(
  "web/referral-settings-update",
  async (payload: UpdateReferralSettingsPayload, thunkAPI) => {
    try {
      const data = await axios.post(`/admin/referral/settings`, payload);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });
        const obj = data?.data?.data;
        thunkAPI.dispatch(SET_REFERRAL_SETTINGS(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);


const initialState: ReferralState = {
  loading_overview: false,
  overview_stats: undefined,
  loading_reward_distribution: false,
  reward_distribution: undefined,
  loading_program_status: false,
  program_status: undefined,
  loading_publish_toggle: false,
  loading_referrals: false,
  referrals: undefined,
  loading_earnings_chart: false,
  earnings_chart: undefined,
  loading_link_expiry_stats: false,
  link_expiry_stats: undefined,
  loading_settings: false,
  referral_settings: undefined,
  loading_settings_update: false,
};

export const referralSlice = createSlice({
  name: "referral",
  initialState,
  reducers: {
    SET_OVERVIEW_STATS: (state, action) => {
      state.overview_stats = action.payload;
    },
    SET_REWARD_DISTRIBUTION: (state, action) => {
      state.reward_distribution = action.payload;
    },
    SET_PROGRAM_STATUS: (state, action) => {
      state.program_status = action.payload;
    },
    SET_REFERRALS: (state, action) => {
      state.referrals = action.payload;
    },
    SET_EARNINGS_CHART: (state, action) => {
      state.earnings_chart = action.payload;
    },
    SET_LINK_EXPIRY_STATS: (state, action) => {
      state.link_expiry_stats = action.payload;
    },
    SET_REFERRAL_SETTINGS: (state, action) => {
      state.referral_settings = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReferralOverviewStat.pending, (state) => {
        state.loading_overview = true;
      })
      .addCase(getReferralOverviewStat.fulfilled, (state) => {
        state.loading_overview = false;
      })
      .addCase(getReferralOverviewStat.rejected, (state) => {
        state.loading_overview = false;
      })
      .addCase(getReferralRewardDistribution.pending, (state) => {
        state.loading_reward_distribution = true;
      })
      .addCase(getReferralRewardDistribution.fulfilled, (state) => {
        state.loading_reward_distribution = false;
      })
      .addCase(getReferralRewardDistribution.rejected, (state) => {
        state.loading_reward_distribution = false;
      })
      .addCase(getReferralProgramStatus.pending, (state) => {
        state.loading_program_status = true;
      })
      .addCase(getReferralProgramStatus.fulfilled, (state) => {
        state.loading_program_status = false;
      })
      .addCase(getReferralProgramStatus.rejected, (state) => {
        state.loading_program_status = false;
      })
      .addCase(publishReferralProgram.pending, (state) => {
        state.loading_publish_toggle = true;
      })
      .addCase(publishReferralProgram.fulfilled, (state) => {
        state.loading_publish_toggle = false;
      })
      .addCase(publishReferralProgram.rejected, (state) => {
        state.loading_publish_toggle = false;
      })
      .addCase(unpublishReferralProgram.pending, (state) => {
        state.loading_publish_toggle = true;
      })
      .addCase(unpublishReferralProgram.fulfilled, (state) => {
        state.loading_publish_toggle = false;
      })
      .addCase(unpublishReferralProgram.rejected, (state) => {
        state.loading_publish_toggle = false;
      })
      .addCase(getReferralList.pending, (state) => {
        state.loading_referrals = true;
      })
      .addCase(getReferralList.fulfilled, (state) => {
        state.loading_referrals = false;
      })
      .addCase(getReferralList.rejected, (state) => {
        state.loading_referrals = false;
      })
      .addCase(getReferralEarningsChart.pending, (state) => {
        state.loading_earnings_chart = true;
      })
      .addCase(getReferralEarningsChart.fulfilled, (state) => {
        state.loading_earnings_chart = false;
      })
      .addCase(getReferralEarningsChart.rejected, (state) => {
        state.loading_earnings_chart = false;
      })
      .addCase(getReferralLinkExpiryStats.pending, (state) => {
        state.loading_link_expiry_stats = true;
      })
      .addCase(getReferralLinkExpiryStats.fulfilled, (state) => {
        state.loading_link_expiry_stats = false;
      })
      .addCase(getReferralLinkExpiryStats.rejected, (state) => {
        state.loading_link_expiry_stats = false;
      })
      .addCase(getReferralSettings.pending, (state) => {
        state.loading_settings = true;
      })
      .addCase(getReferralSettings.fulfilled, (state) => {
        state.loading_settings = false;
      })
      .addCase(getReferralSettings.rejected, (state) => {
        state.loading_settings = false;
      })
      .addCase(updateReferralSettings.pending, (state) => {
        state.loading_settings_update = true;
      })
      .addCase(updateReferralSettings.fulfilled, (state) => {
        state.loading_settings_update = false;
      })
      .addCase(updateReferralSettings.rejected, (state) => {
        state.loading_settings_update = false;
      })

  },
});

// Action creators are generated for each case reducer function
export const {
  SET_OVERVIEW_STATS,
  SET_REWARD_DISTRIBUTION,
  SET_PROGRAM_STATUS,
  SET_REFERRALS,
  SET_EARNINGS_CHART,
  SET_LINK_EXPIRY_STATS,
  SET_REFERRAL_SETTINGS,
} = referralSlice.actions;

export default referralSlice.reducer;
